import type {KeyTextField} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import type {Top10AiToolsSliceDefaultPrimaryTakeawaysItem} from 'prismicio-types'
import React from 'react'

interface Props {
  eyebrow: KeyTextField
  title: KeyTextField
  takeaways: Top10AiToolsSliceDefaultPrimaryTakeawaysItem[]
}

const KeyTakeaways: React.FC<Props> = ({eyebrow, title, takeaways}) => (
  <section className="t10-section t10-section-alt">
    <div className="t10-wrap">
      {eyebrow && <p className="t10-eyebrow">{eyebrow}</p>}
      {title && (
        <h2 className="t10-section-title" style={{maxWidth: '20ch', marginBottom: 56}}>
          {title}
        </h2>
      )}
      {takeaways && takeaways.length > 0 && (
        <div className="t10-takeaways-grid">
          {takeaways.map((t, i) => (
            <div key={i} className="t10-trend-card">
              <p className="t10-takeaway-num">{t.num}</p>
              <div className="t10-takeaway-text">
                <PrismicRichText field={t.text} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </section>
)

export default KeyTakeaways
